import React, { useState, useRef } from 'react';
import { obterVideoPrevia } from '../../servicos/api';
import { useAutenticacao } from '../../contextos/AutenticacaoContexto';
import styles from './Download.module.css';
import CarregandoSobreposto from '../CarregandoSobreposto/CarregandoSobreposto';

const Download = () => {
  const [url, setUrl] = useState('');
  const [videoPrevia, setVideoPrevia] = useState(null);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [estadoVideo, setEstadoVideo] = useState('vazio'); // vazio, preview, pronto
  const videoRef = useRef(null);
  const { usuario, fazerLogout } = useAutenticacao();

  const validarUrl = (urlTexto) => {
    try {
      // aceita qualquer URL válida, sem restrição de domínio
      new URL(urlTexto);
      return true;
    } catch {
      return false;
    }
  };

  const handleBuscarVideo = async (e) => {
    e.preventDefault();
    setErro('');
    setEstadoVideo('vazio');

    if (!url.trim()) {
      setErro('Por favor, insira uma URL válida');
      return;
    }

    if (!validarUrl(url)) {
      setErro('A URL é inválida');
      return;
    }

    setCarregando(true);

    try {
      const { url: urlVideo, blob } = await obterVideoPrevia(url);
      setVideoPrevia({ url: urlVideo, blob });
      setEstadoVideo('preview');
    } catch (error) {
      console.error('handleBuscarVideo erro:', error);
      const mensagem = typeof error === 'string'
        ? error
        : error?.message || 'Erro ao buscar o vídeo. Verifique a URL e tente novamente.';
      setErro(mensagem);
      setEstadoVideo('vazio');
    } finally {
      setCarregando(false);
    }
  };

  const handleBaixarVideo = async () => {
    if (!videoPrevia) return;

    setCarregando(true);

    try {
      // Cria link de download
      const link = document.createElement('a');
      link.href = videoPrevia.url;
      link.download = `video_${Date.now()}.mp4`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setErro('');
      setEstadoVideo('pronto');

      // Aguarda um pouco e limpa
      setTimeout(() => {
        setUrl('');
        setVideoPrevia(null);
        setEstadoVideo('vazio');
      }, 2000);
    } catch (error) {
      setErro('Erro ao baixar o vídeo. Tente novamente.');
    } finally {
      setCarregando(false);
    }
  };

  const handleLimpar = () => {
    setUrl('');
    setVideoPrevia(null);
    setErro('');
    setEstadoVideo('vazio');
  };

  const handleNovaUrl = () => {
    handleLimpar();
  };

  return (
    <>
      {carregando && <CarregandoSobreposto />}
      <div className={styles.container}>
        <div className={styles.cabecalho}>
          <h1 className={styles.titulo}>Baixador de Vídeos</h1>
          <div className={styles.usuarioInfo}>
            <span className={styles.nomeUsuario}>{usuario}</span>
            <button className={styles.botaoSair} onClick={fazerLogout}>
              Sair
            </button>
          </div>
        </div>

        <div className={styles.conteudo}>
          {estadoVideo === 'vazio' && (
            <div className={styles.cartaoBusca}>
              <h2 className={styles.subtitulo}>Insira a URL do vídeo</h2>

              <form onSubmit={handleBuscarVideo} className={styles.formulario}>
                <div className={styles.grupoEntrada}>
                  <input
                    type="text"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    placeholder="Cole aqui o link do vídeo (qualquer fonte pública)"
                    className={styles.entrada}
                    disabled={carregando}
                  />
                  <button
                    type="submit"
                    className={styles.botaoBuscar}
                    disabled={carregando}
                  >
                    {carregando ? 'Buscando...' : 'Buscar Vídeo'}
                  </button>
                </div>

                {erro && <div className={styles.mensagemErro}>{erro}</div>}
              </form>

              <div className={styles.instrucoes}>
                <h3>Como usar:</h3>
                <ol>
                  <li>Use um link público de vídeo</li>
                  <li>Copie a URL do vídeo desejado</li>
                  <li>Cole aqui e clique em "Buscar Vídeo"</li>
                  <li>Visualize o vídeo e faça o download</li>
                </ol>
              </div>
            </div>
          )}

          {estadoVideo === 'preview' && videoPrevia && (
            <div className={styles.cartaoPrevia}>
              <h2 className={styles.subtitulo}>Visualize seu vídeo</h2>

              <div className={styles.containerVideo}>
                <video
                  ref={videoRef}
                  src={videoPrevia.url}
                  controls
                  className={styles.video}
                />
              </div>

              <div className={styles.acoesPrevia}>
                <button
                  className={styles.botaoBaixar}
                  onClick={handleBaixarVideo}
                  disabled={carregando}
                >
                  {carregando ? 'Baixando...' : '⬇ Baixar Vídeo'}
                </button>
                <button
                  className={styles.botaoNovaUrl}
                  onClick={handleNovaUrl}
                  disabled={carregando}
                >
                  ✕ Cancelar
                </button>
              </div>

              {erro && <div className={styles.mensagemErro}>{erro}</div>}
            </div>
          )}

          {estadoVideo === 'pronto' && (
            <div className={styles.cartaoSucesso}>
              <div className={styles.iconeeSucesso}>✓</div>
              <h2 className={styles.subtitulo}>Pronto!</h2>
              <p className={styles.mensagemSucesso}>
                Seu vídeo foi baixado com sucesso
              </p>
              <button
                className={styles.botaoNovo}
                onClick={handleNovaUrl}
              >
                Baixar outro vídeo
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Download;
